import React from 'react';

const FullWidthPhoto = ({ photo, alt, caption }) => {
  return (
    <div className="fullWidth">
      <img src={photo} alt={alt} />
      <p className="inline__caption__text">{caption}</p>
    </div>
  );
};

export default FullWidthPhoto;
